export const EmailLink = ({ email, subject, body, withIcon = true }) => {
    if (!email) return null;

    // Split by comma or semicolon and trim whitespace
    const emails = email.split(/[,;]/).map(e => e.trim()).filter(e => e);
    if (emails.length === 0) return null;

    const buildMailto = (addr) => {
        let mailto = `mailto:${addr}`;
        const params = [];

        if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
        if (body) params.push(`body=${encodeURIComponent(body)}`);

        if (params.length > 0) mailto += `?${params.join("&")}`;
        return mailto;
    };

    // If only one email, use the original logic
    if (emails.length === 1) {
        return (
            <a href={buildMailto(emails[0])} style={{ color: "rgb(41, 156, 219)" }} className="flex items-center gap-2">
                {withIcon && <><i className="ri-mail-line text-muted" />{" "}</>}
                <span className="text-wrap">{emails[0]}</span>
            </a>
        );
    }

    return (
        <div className="flex items-center gap-2">
            {withIcon && <><i className="ri-mail-line text-muted" />{" "}</>}
            <>
                {emails.map((e, index) => (
                    <span key={index}>
                        {index > 0 && <span style={{ marginLeft: '1rem' }} />}
                        <a className="text-wrap" href={buildMailto(e)} style={{ color: "rgb(41, 156, 219)" }}>
                            {e}
                        </a>
                        {index < emails.length - 1 && <br />}
                    </span>
                ))}
            </>
        </div>
    );
};